import api from '../../models/reportsummarybypart'
import moment from 'moment'

export default {
  data() {
    return {
      date: '',
      search_text: '',
      data: [],
      is_load: false,
      result_data: [],
      count: 0,
      str_data: '',
      export_url: '',
      dk_id: '0',
      dockList: [],
    }
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      this.getDockList()
      this.date = moment()
      $('#select2-dock').select2({
        placeholder: '- Select Dock -',
        allowClear: true,
        dropdownPosition: 'below',
      })
      $('#select2-dock').on('select2:select', (e) => {
        this.changeDock($('#select2-dock').val())
      })
      $('#select2-dock').on('select2:clear', (e) => {
        this.changeDock('0')
      })
    }, 1000)
  },
  methods: {
    getDockList() {
      this.dockList = []
      api.getDockList(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.dockList = result.data.dock_list
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    changeDock(id) {
      this.dk_id = id
      this.search()
    },
    exportData(type) {
      // eslint-disable-next-line no-undef
      $('.preloader').fadeIn()
      var obj = {
        search: this.search_text,
        dk_id: this.dk_id,
        date: this.dateFormatDMY2(this.date),
      }
      this.header.params = obj
      api.ReportSummaryBYPart(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.str_data = JSON.stringify(result.data)
            setTimeout(() => {
              if (type === 1) {
                this.$refs.ExportPDF.submit()
              } else {
                this.$refs.ExportExcel.submit()
              }
              // eslint-disable-next-line no-undef
              $('.preloader').fadeOut()
            }, 1000)
          } else {
            this.alert_msg('warning', 'Report Summary by Part', result.message)
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          }
          this.isLoad = false
        },
        (error) => {
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut()
          this.alert_msg('error', 'Report Summary by Part', error.message)
          this.isLoad = false
        }
      )
    },
    search() {
      this.is_load = true
      var obj = {
        search: this.search_text,
        dk_id: this.dk_id,
        date: this.dateFormatDMY2(this.date),
      }
      this.result_data = []
      this.header.params = obj
      api.ReportSummaryBYPart(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
            this.count = result.count
          } else {
            this.alert_msg('warning', 'Report Summary by Part', result.message)
          }
          this.is_load = false
        },
        (error) => {
          this.alert_msg('error', 'Report Summary by Part', error.message)
          this.is_load = false
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/reportsummarybypart.js